import React from 'react';
import styled from 'styled-components';
import { Level, Title } from 'rbx';
import { withRouter } from 'react-router-dom';
import { omit } from 'lodash';
import qs from 'querystringify';
import { Input, Radio, Select } from '../../../components/elements';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const TitleWrapper = styled.nav`
  padding-right: 0.5rem;
`;

const StatusType = ({ status, handlePush }) => (
  <Level.Item style={{ marginTop: '30px' }}>
    <Level.Item>
      <TitleWrapper style={{ paddingLeft: '0.5rem' }}>
        <Title className="label">Status</Title>
      </TitleWrapper>
    </Level.Item>
    <Level.Item style={{ marginRight: '10px' }}>
      <div>
        <Radio
          label="ACTIVE"
          name="Type"
          value={status === 'ACTIVE'}
          onChange={() => handlePush({ status: 'ACTIVE' }, 'status')}
        />
      </div>
    </Level.Item>
    <Level.Item>
      <div>
        <Radio
          label="INACTIVE"
          name="Type"
          value={status === 'INACTIVE'}
          onChange={() => handlePush({ status: 'INACTIVE' }, 'status')}
        />
      </div>
    </Level.Item>
  </Level.Item>
);

const filterOptions = [
  { value: 'cms_socials', label: 'SOCIALS' },
  { value: 'cms_cuisine_styles', label: 'CUISINE STYLES' },
  { value: 'cms_taxes', label: 'TAXES' },
  { value: 'cms_item_types', label: 'ITEM TYPES' },
  { value: 'cms_place_ambience', label: 'PLACE AMBIENCE' },
  { value: 'cms_place_business_type', label: 'PLACE BUSINESS TYPE' },
  { value: 'cms_place_dietary_info', label: 'PLACE DIETARY INFO' },
  { value: 'cms_place_dining_style', label: 'PLACE DINING STYLE' },
  { value: 'cms_place_dress_code', label: 'PLACE DRESS CODE' },
  { value: 'cms_place_good_for', label: 'PLACE GOOD FOR' },
  { value: 'cms_place_noise_level', label: 'PLACE NOISE LEVEL' },
  { value: 'cms_place_service_category', label: 'PLACE SERVICE CATEGORY' },
  { value: 'cms_place_service_type', label: 'PLACE SERVICE TYPE' },
  { value: 'cms_common_feature', label: 'COMMON FEATURE' },
  { value: 'cms_common_parking_detail', label: 'COMMON PARKING DETAIL' },
  { value: 'cms_common_public_transport', label: 'COMMON PUBLIC TRANSPORT' },
  { value: 'cms_contact_type', label: 'CONTACT TYPE' },
  { value: 'cms_contact_feedback_type', label: 'CONTACT FEEDBACK TYPE' },
  { value: 'cms_fee_value_type', label: 'FEEVALUE TYPE' },
  { value: 'cms_general_fee', label: 'GENERAL FEE' },
  { value: 'cms_subject_type', label: 'SUBJECT TYPE' },
  { value: 'cms_place_menu_deal_type', label: 'PLACE MENU DEAL TYPE' },
];

const Search = ({ name, status, routeState, history, cmsDataType }) => {
  const handlePush = (args, key) => {
    const newRoutState = omit(routeState, key);
    history.push(
      `/cms-data${qs.stringify(
        {
          ...newRoutState,
          ...args,
          page: 1,
        },
        true,
      )}`,
    );
  };

  return (
    <>
      <Wrapper>
        <BoxWrapper className="box">
          <div className="columns">
            <div className="column is-4">
              <Input
                label="Name"
                type="text"
                id="cms_data_name"
                value={name}
                onChange={place => {
                  handlePush({ name: place.target.value }, 'name');
                }}
                placeholder="Start entering name..."
              />
            </div>
            <div className="column is-4">
              <StatusType
                status={status}
                handlePush={handlePush}
                key={status}
              />
            </div>
          </div>
          <div className="columns">
            <div className="column is-4">
              <Select
                options={filterOptions}
                value={filterOptions.find(ele => ele.value === cmsDataType)}
                onChange={({ value }) => {
                  handlePush({ cmsDataType: value }, 'cmsDataType');
                }}
                key={cmsDataType}
              />
            </div>
          </div>
        </BoxWrapper>
      </Wrapper>
    </>
  );
};

export default withRouter(Search);
